import { Configuration } from '@gslc/models';

export const openApiConfig = (): Configuration =>
  new Configuration({
    basePath: process.env.VUE_APP_API_URL || 'https://api.gslc.com/',
    baseOptions: {
      headers: {
        'Cache-Control': 'default',
      },
    },
  });
